import { createFileRoute } from "@tanstack/react-router";
import AdminCardsPage from "@/admin/pages/cards";

type AdminCardsSearch = {
  status?: "draft" | "published" | "retired";
  premium?: "free" | "premium";
  type?: string;
  creator?: string;
  category?: string;
  sort?: "recent" | "popular" | "name";
  q?: string;
};

const STATUSES = new Set(["draft", "published", "retired"]);
const SORTS = new Set(["recent", "popular", "name"]);

export const Route = createFileRoute("/admin/cards/")({
  component: AdminCardsPage,
  validateSearch: (search: Record<string, unknown>): AdminCardsSearch => ({
    status:
      typeof search.status === "string" && STATUSES.has(search.status)
        ? (search.status as AdminCardsSearch["status"])
        : undefined,
    premium: search.premium === "free" || search.premium === "premium" ? search.premium : undefined,
    type: typeof search.type === "string" && search.type ? search.type : undefined,
    creator: typeof search.creator === "string" && search.creator ? search.creator : undefined,
    category: typeof search.category === "string" && search.category ? search.category : undefined,
    sort:
      typeof search.sort === "string" && SORTS.has(search.sort)
        ? (search.sort as AdminCardsSearch["sort"])
        : undefined,
    q: typeof search.q === "string" && search.q ? search.q : undefined,
  }),
});
